module.exports = __webpack_public_path__ + "img/laser.3a53980a.png";